import script from "./kaojiang.vue?vue&type=script&setup=true&lang=js"
export * from "./kaojiang.vue?vue&type=script&setup=true&lang=js"

import "./kaojiang.vue?vue&type=style&index=0&id=458f3440&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458f3440"]])

export default __exports__